import React, { useContext } from "react";
import { Link, useLocation } from 'react-router-dom'

import { TopNav } from '../../components';
import { SettingsContext } from '../../contexts';

const Categories = props => {
    const location  = useLocation()
    // Audit: hide the legacy SHOP / ORDER / SELL top nav on Retail Circle.
    // The RC sidebar provides primary navigation; these links point at the
    // public DAO Watches storefront flow which RC users never land on.
    const { isRetailCircle } = useContext(SettingsContext) || {};
    if (isRetailCircle) return null;

    const navOptions = [
        ['/products/watches', 'Shop'],
        ['/request/order', 'Order', { reset: true }],
        ['/request/sell', 'Sell', { reset: true }],
    ];

    if (window.SHOW_BAGS) {
        navOptions.push(['/products/bags', 'Bags'])
    }

    if (window.SHOW_CIGARS) {
        navOptions.push(['/products/cigars', 'Cigars'])
    }

    const navItems = navOptions.map(function(option) {
        const urlPart = location.pathname.split('/').slice(0, 3).join('/')

        return {
            to: option[0],
            label: option[1],
            active: urlPart === option[0],
            locationState: option[2],
        };
    })

    return (
        <TopNav items={navItems} />
    );
}

export default Categories;
